import React from 'react';

import Matching, { onChangePayload } from './Matching';

type MatchingWrapperProps = {
  question: any;
  tracking: any;
  config: any;
  onChange: Function;
};

function MatchingWrapper(props: MatchingWrapperProps) {
  const { question, tracking, config, onChange } = props;
  const { showCorrectAnswer, showYourAnswers } = config;
  const { answer, submitted } = tracking;

  function handleOnChange(payload: onChangePayload) {
    onChange &&
      onChange(undefined, {
        value: payload.completed ? payload : undefined, // to avoid submit when incomplete
        questionId: question.resourceId,
      });
  }

  return (
    <div style={{ marginTop: '10px' }}>
      <Matching
        matchingItems={question?.matchingItems}
        matchingResponse={submitted ? answer?.response : undefined}
        sameHeight
        width={200}
        onChange={handleOnChange}
        showFeedback={submitted && (showCorrectAnswer || showYourAnswers)}
        disabled={submitted}
      />
    </div>
  );
}

export default MatchingWrapper;
